export const persistConfig = {
  storage: window.sessionStorage,
  expireIn: 86400000, // One day in milliseconds
  removeOnExpiration: true,
};
